<div class="close-modal">
    <button (click)="activeModal.close()">
        <app-icon [type]="'X'"></app-icon>
    </button>
</div>
<div class="modal-body gtm-lti-continue-modal">
    <div class="title">Interactive Lesson Sign In</div>
    <div class="advice">
        Sign in to your PBS LearningMedia account to save your progress and submit your work, or
        continue as a guest.
    </div>
    <div class="buttons-wrapper">
        <button
            type="button"
            class="sign-in selenium-lti-login gtm-lti-login"
            (click)="openLTILoginModal()"
        >
            Sign In
        </button>
        <button
            type="button"
            class="continue-as selenium-lti-continue-as-guest gtm-lti-continue-as-guest"
            (click)="goToLTIAsGuest()"
        >
            Continue as a Guest
        </button>
    </div>
</div>
